(function () {
  function initArticleShortcodeProductForms() {
    if (!window.theme || !theme.applyAjaxToProductForm || !window.jQuery) {
      return;
    }

    window.jQuery('.article-shortcode-product-form').each(function () {
      theme.applyAjaxToProductForm(window.jQuery(this));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initArticleShortcodeProductForms);
  } else {
    initArticleShortcodeProductForms();
  }
})();
